import { Swiper } from '@services';
import { M as Mousewheel } from './mousewheel-C5j9rBbp.js';
import './utils-BgX2tuHA.js';

class PredictiveSearchSuggestions extends HTMLElement {
  swiper = this.querySelector('.swiper');

  connectedCallback() {
    this.initSwiper();
  }

  initSwiper() {
    if (!this.swiper) return;

    new Swiper(this.swiper, {
      modules: [Mousewheel],
      slidesPerView: 'auto',
      spaceBetween: 24,
      slidesOffsetAfter: -24,
      mousewheel: {
        enabled: true,
        releaseOnEdges: true,
      },
    });
  }
}

customElements.define('predictive-search-suggestions', PredictiveSearchSuggestions);
